module.exports = __webpack_public_path__ + "static/media/fanyuvo_logo_big.b170d51d.png";